// Test IDs for the ListingForm feature.
//
// Only test IDs that are BOTH referenced by validation logic AND by markup
// belong here — the goal of centralizing is to prevent drift between the
// two. Locally-scoped test IDs used only for QA hooks stay inline in JSX.
//
// See ./index.js for the recipe to add a new feature file.
// Keys: camelCase. Values: kebab-case shaped as `<feature>-<element>`.

export const LISTING_FORM = {
        // Step 1 — Photos
        uploadImageBtn: 'upload-image-btn',
        // Step 2 — Details
        titleInput: 'listing-title-input',
        categoriesBlock: 'listing-categories-block',
        priceInput: 'listing-price-input',
        tagInput: 'tag-input',
};
